import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import classes from "./SalesConfigPanel.module.css";
import Checkbox from "../../framework/Checkbox";
import { useSelector } from "react-redux";
import NumberInput from "../../framework/NumberInput";
import { displayToast } from "../../framework/toast/toastUtils";
import GlobalContext from "../../framework/GlobalContext";
import { executeScroll } from "../../utils/utils";
import SelectInput from "../../framework/SelectInput";
import { getPaymentModes } from "../../services/payment-services";
import ConfigurationContext from "./ConfigurationContext";
// import { CASH, CREDIT } from "../../common/payments";

const ReturnsConfigPanel = (props) => {
  const {
    VALIDATE_DISTRIBUTOR_ON_PURCHASE_RETURN,
    ALLOW_UNVALIDATED_SALES_RETURN,
    ACTIVATE_INVOICE_SCAN,
    DEFAULT_SALES_RETURN_PAYMENT_MODE_ID = "1SF",
    MAX_EXPIRY_DAYS_ALLOWED_FOR_SALES_RETURN,
    SET_EXPIRY_DEDUCTION_PERCENTAGE,
    FORCE_REMARKS_ON_SALES_RETURN,
    SALES_RETURNABLE_DAYS,
    ALLOW_CREDIT_RETURNS,
    MAX_RETURNABLE_QUANTITY,
  } = useSelector(
    (state) =>
      state.commonReducer.tabs[state.commonReducer.activeTabIndex].configData
  );
  const { formLabels } = useContext(ConfigurationContext);

  const { focusField } = useContext(GlobalContext);
  const unvalidatedSalesReturnRef = useRef();
  const allowInvoiceRef = useRef();
  const forceRemarksRef = useRef();
  const salesReturnRemarksRef = useRef();
  const maxExpAllowsForSalesReturnRef = useRef();
  const maxDaysForSalesReturnRef = useRef();
  const validateDistributorPurchaseRef = useRef();
  const expReturnDeductionPerRef = useRef();
  const maxReturnableQuantityRef = useRef();
  const filterPaymentModeRef = useRef();

  const [paymentModes, setPaymentModes] = useState([]);

  const [defaultPaymentMode, setDefaultPaymentMode] = useState(null);
  const [
    maxExpiryDaysAllowedForSalesReturn,
    setMaxExpiryDaysAllowedForSalesReturn,
  ] = useState(MAX_EXPIRY_DAYS_ALLOWED_FOR_SALES_RETURN);

  const [maxDaysAllowedForSalesReturn, setMaxDaysAllowedForSalesReturn] =
    useState(SALES_RETURNABLE_DAYS);

  const [expiryDeductionPercentage, setExpiryDeductionPercentage] = useState(
    SET_EXPIRY_DEDUCTION_PERCENTAGE
  );
  const [maxReturnableQuantity, setMaxReturnableQuantity] = useState(
    MAX_RETURNABLE_QUANTITY
  );

  useEffect(() => {
    focusField("config_return_allow_unvalidated_sales_return");
    unvalidatedSalesReturnRef?.current.focus({ preventScroll: true });
  }, [focusField]);

  const getPaymentModesList = useCallback(() => {
    getPaymentModes(`showsIn=SALES_RETURN`).then((response) => {
      let obj = response?.map((value) => {
        return {
          ...value,
          id: value.paymentModeId,
          label: value.paymentMode,
        };
      });
      setPaymentModes(obj);
    });
  }, []);

  useEffect(() => {
    if (!paymentModes?.length) getPaymentModesList();
  }, [getPaymentModesList, paymentModes]);

  useEffect(() => {
    if (!defaultPaymentMode && paymentModes?.length) {
      let paymentType = paymentModes?.find(
        (opn) => opn.id === DEFAULT_SALES_RETURN_PAYMENT_MODE_ID
      );
      setDefaultPaymentMode(paymentType);
    }
  }, [DEFAULT_SALES_RETURN_PAYMENT_MODE_ID, defaultPaymentMode, paymentModes]);

  return (
    <div className={classes["salesconfigpanel-main-container"]}>
      <div className={classes["salesconfig-text-style"]}>Returns Setting</div>
      <div className={classes["salesconfig-sub-container"]}>
        <div className={classes["salesconfig-left-container"]}>
          <div className={classes["salesconfig-margin-section"]}>
            <div className={classes["salesconfig-margin-text"]}>
              Sales Return Settings
            </div>

            <Checkbox
              id="config_return_allow_unvalidated_sales_return"
              name="unvalidatedSalesReturn"
              ref={unvalidatedSalesReturnRef}
              label={formLabels?.ALLOW_UNVALIDATED_SALES_RETURN?.displayName}
              checked={ALLOW_UNVALIDATED_SALES_RETURN}
              onFocus={() => {
                executeScroll(unvalidatedSalesReturnRef);
                focusField("config_return_allow_unvalidated_sales_return");
              }}
              onChange={(e) => {
                //setInvalidatedSalesReturn(e.target.checked);
                props.handleFormChange(
                  "ALLOW_UNVALIDATED_SALES_RETURN",
                  e.target.checked,
                  "returns"
                );
                if (ACTIVATE_INVOICE_SCAN) {
                  setTimeout(() => {
                    props.handleFormChange(
                      "ACTIVATE_INVOICE_SCAN",
                      false,
                      "returns"
                    );
                  }, 100);
                }
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_return_allow_unvalidated_sales_return",
                  down: !ALLOW_UNVALIDATED_SALES_RETURN
                    ? "config_return_allow_invoice"
                    : "config_return_force_remark_transaction",
                  left: "config_return_allow_unvalidated_sales_return",
                  right: !ALLOW_UNVALIDATED_SALES_RETURN
                    ? "config_return_allow_invoice"
                    : "config_return_force_remark_transaction",
                }),
              }}
            />
            <br />
            <Checkbox
              id="config_return_allow_invoice"
              name="allowInvoice"
              ref={allowInvoiceRef}
              label={formLabels?.ACTIVATE_INVOICE_SCAN?.displayName}
              checked={ACTIVATE_INVOICE_SCAN}
              disabled={ALLOW_UNVALIDATED_SALES_RETURN}
              onFocus={() => {
                executeScroll(allowInvoiceRef);
                focusField("config_return_allow_invoice");
              }}
              onChange={(e) => {
                //setInvalidatedSalesReturn(e.target.checked);
                props.handleFormChange(
                  "ACTIVATE_INVOICE_SCAN",
                  e.target.checked,
                  "returns"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_return_allow_unvalidated_sales_return",
                  down: "config_return_force_remark_transaction",
                  left: "config_return_allow_unvalidated_sales_return",
                  right: "config_return_force_remark_transaction",
                }),
              }}
            />
            <br />
            <Checkbox
              id="config_return_force_remark_transaction"
              name="forceRemarks"
              ref={forceRemarksRef}
              label={formLabels?.FORCE_REMARKS_ON_SALES_RETURN?.displayName}
              checked={FORCE_REMARKS_ON_SALES_RETURN}
              onFocus={() => {
                executeScroll(forceRemarksRef);
                focusField("config_return_force_remark_transaction");
              }}
              onChange={(e) => {
                // setForceRemarksOnSalesReturn(e.target.checked);
                props.handleFormChange(
                  "FORCE_REMARKS_ON_SALES_RETURN",
                  e.target.checked,
                  "returns"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: !ALLOW_UNVALIDATED_SALES_RETURN
                    ? "config_return_allow_invoice"
                    : "config_return_allow_unvalidated_sales_return",
                  down: "config_return_sales_return_remark",
                  left: !ALLOW_UNVALIDATED_SALES_RETURN
                    ? "config_return_allow_invoice"
                    : "config_return_allow_unvalidated_sales_return",
                  right: "config_return_sales_return_remark",
                }),
              }}
            />
            <br />
            <Checkbox
              id="config_return_sales_return_remark"
              name="salesReturnRemarks"
              ref={salesReturnRemarksRef}
              label={formLabels?.ALLOW_CREDIT_RETURNS?.displayName}
              checked={ALLOW_CREDIT_RETURNS}
              onFocus={() => {
                executeScroll(salesReturnRemarksRef);
                focusField("config_return_sales_return_remark");
              }}
              onChange={(e) => {
                if (!e.target.checked) {
                  if (DEFAULT_SALES_RETURN_PAYMENT_MODE_ID === "2SF") {
                    displayToast({ type: "warn", title: "Changing to CASH." });
                  }
                  let paymentType = paymentModes?.find(
                    (opn) => opn.id === "1SF"
                  );
                  setDefaultPaymentMode(paymentType);
                  setTimeout(() => {
                    props.handleFormChange(
                      "DEFAULT_SALES_RETURN_PAYMENT_MODE_ID",
                      "1SF",
                      "returns"
                    );
                  }, 500);
                }

                // setForceRemarksOnSalesReturn(e.target.checked);
                props.handleFormChange(
                  "ALLOW_CREDIT_RETURNS",
                  e.target.checked,
                  "returns"
                );
                setTimeout(() => {
                  getPaymentModesList();
                }, 500);
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_return_force_remark_transaction",
                  down: "payment-modes-select",
                  left: "config_return_force_remark_transaction",
                  right: "payment-modes-select",
                }),
              }}
            />
            <br />

            <div className={classes["salesconfig-textbox-wrapper"]}>
              Default Payment Mode
            </div>

            <div className={classes["salesconfig-textbox-wrapper"]}>
              <SelectInput
                id="config_return_filter_payment"
                label={
                  formLabels?.DEFAULT_SALES_RETURN_PAYMENT_MODE_ID?.displayName
                }
                value={defaultPaymentMode}
                isOptionEqualToValue={(option, value) => {
                  return option.id === value.id;
                }}
                onChange={(e, newValue) => {
                  setDefaultPaymentMode(newValue);
                  props.handleFormChange(
                    "DEFAULT_SALES_RETURN_PAYMENT_MODE_ID",
                    newValue.id,
                    "returns"
                  );
                }}
                onFocus={() => {
                  executeScroll(filterPaymentModeRef);
                  focusField("config_return_filter_payment");
                }}
                options={paymentModes}
                getOptionLabel={(option) => {
                  return option.label;
                }}
                markers={{
                  up: "config_return_sales_return_remark",
                  down: "config_return_max_expiry_allowed_for_sales_return",
                  left: "config_return_sales_return_remark",
                  right: "config_return_max_expiry_allowed_for_sales_return",
                }}
              />
            </div>

            <div className={classes["salesconfig-textbox-wrapper"]}>
              <NumberInput
                id="config_return_max_expiry_allowed_for_sales_return"
                name="maxExpAllowsForSalesReturn"
                ref={maxExpAllowsForSalesReturnRef}
                label={
                  formLabels?.MAX_EXPIRY_DAYS_ALLOWED_FOR_SALES_RETURN
                    ?.displayName
                }
                onFocus={() => {
                  executeScroll(maxExpAllowsForSalesReturnRef);
                  focusField(
                    "config_return_max_expiry_allowed_for_sales_return"
                  );
                }}
                value={maxExpiryDaysAllowedForSalesReturn}
                onValueChange={(values, e) => {
                  setMaxExpiryDaysAllowedForSalesReturn(values.floatValue);
                  props.handleFormChange(
                    "MAX_EXPIRY_DAYS_ALLOWED_FOR_SALES_RETURN",
                    values.floatValue
                  );
                }}
                //onBlur={() => validateForm("distributorName", formState, errorState)}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "config_return_filter_payment",
                    down: "config_return_max_days_allowed_for_sales_return",
                    left: "config_return_filter_payment",
                    right: "config_return_max_days_allowed_for_sales_return",
                  }),
                }}
                //   error={checkErrorStateExists(
                //     "purchase_edit_distributor_name",
                //     errorState
                //   )}
              />
            </div>

            <div className={classes["salesconfig-textbox-wrapper"]}>
              <NumberInput
                id="config_return_max_days_allowed_for_sales_return"
                name="maxDaysForSalesReturn"
                ref={maxDaysForSalesReturnRef}
                decimalScale={0}
                label={formLabels?.SALES_RETURNABLE_DAYS?.displayName}
                onFocus={() => {
                  executeScroll(maxDaysForSalesReturnRef);
                  focusField("config_return_max_days_allowed_for_sales_return");
                }}
                value={maxDaysAllowedForSalesReturn}
                onValueChange={(values, e) => {
                  setMaxDaysAllowedForSalesReturn(values.floatValue);
                  props.handleFormChange(
                    "SALES_RETURNABLE_DAYS",
                    values.floatValue
                  );
                }}
                //onBlur={() => validateForm("distributorName", formState, errorState)}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "config_return_max_expiry_allowed_for_sales_return",
                    down: "config_return_validate_distributor_on_purchase_return",
                    left: "config_return_max_expiry_allowed_for_sales_return",
                    right:
                      "config_return_validate_distributor_on_purchase_return",
                  }),
                }}
                //   error={checkErrorStateExists(
                //     "purchase_edit_distributor_name",
                //     errorState
                //   )}
              />
            </div>
          </div>
          <div className={classes["salesconfig-discount-section"]}>
            <div className={classes["salesconfig-discount-settings-text"]}>
              Purchase Return Settings
            </div>
            <Checkbox
              id="config_return_validate_distributor_on_purchase_return"
              name="ValidateDistributorPurchase"
              ref={validateDistributorPurchaseRef}
              label={
                formLabels?.VALIDATE_DISTRIBUTOR_ON_PURCHASE_RETURN?.displayName
              }
              checked={VALIDATE_DISTRIBUTOR_ON_PURCHASE_RETURN}
              onFocus={() => {
                executeScroll(validateDistributorPurchaseRef);
                focusField(
                  "config_return_validate_distributor_on_purchase_return"
                );
              }}
              onChange={(e) => {
                //setValidateDistributorOnPurchaseReturn(e.target.checked);
                props.handleFormChange(
                  "VALIDATE_DISTRIBUTOR_ON_PURCHASE_RETURN",
                  e.target.checked,
                  "returns"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "config_return_max_days_allowed_for_sales_return",
                  down: "config_return_set_expiry_return_deduction_percent",
                  left: "config_return_max_days_allowed_for_sales_return",
                  right: "config_return_set_expiry_return_deduction_percent",
                }),
              }}
            />
            <div className={classes["salesconfig-textbox-wrapper"]}>
              <NumberInput
                id="config_return_set_expiry_return_deduction_percent"
                name="expReturnDeductionPer"
                ref={expReturnDeductionPerRef}
                label={formLabels?.SET_EXPIRY_DEDUCTION_PERCENTAGE?.displayName}
                onFocus={() => {
                  executeScroll(expReturnDeductionPerRef);
                  focusField(
                    "config_return_set_expiry_return_deduction_percent"
                  );
                }}
                value={expiryDeductionPercentage}
                onValueChange={(values, e) => {
                  setExpiryDeductionPercentage(values.floatValue);
                  props.handleFormChange(
                    "SET_EXPIRY_DEDUCTION_PERCENTAGE",
                    values.floatValue,
                    "Returns"
                  );
                }}
                //onBlur={() => validateForm("distributorName", formState, errorState)}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "config_return_validate_distributor_on_purchase_return",
                    down: "config_return_max_returnable_quantity",
                    left: "config_return_validate_distributor_on_purchase_return",
                    right: "config_return_max_returnable_quantity",
                  }),
                }}
                //   error={checkErrorStateExists(
                //     "purchase_edit_distributor_name",
                //     errorState
                //   )}
              />
            </div>
            <div className={classes["salesconfig-textbox-wrapper"]}>
              <NumberInput
                id="config_return_max_returnable_quantity"
                name="maxReturnableQuantity"
                ref={maxReturnableQuantityRef}
                label={formLabels?.MAX_RETURNABLE_QUANTITY?.displayName}
                onFocus={() => {
                  executeScroll(maxReturnableQuantityRef);
                  focusField("config_return_max_returnable_quantity");
                }}
                value={maxReturnableQuantity}
                onValueChange={(values, e) => {
                  setMaxReturnableQuantity(values.floatValue);
                  props.handleFormChange(
                    "MAX_RETURNABLE_QUANTITY",
                    values.floatValue,
                    "Returns"
                  );
                }}
                //onBlur={() => validateForm("distributorName", formState, errorState)}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "config_return_set_expiry_return_deduction_percent",
                    down: "config_return_max_returnable_quantity",
                    left: "config_return_set_expiry_return_deduction_percent",
                    right: "config_return_max_returnable_quantity",
                  }),
                }}
                //   error={checkErrorStateExists(
                //     "purchase_edit_distributor_name",
                //     errorState
                //   )}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnsConfigPanel;
